import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createNewsLetter, deleteNewsLetter, fetchNewsLetter, fetchNewsLetterById, fetchNewsLetterDetails, updateNewsLetter } from "../../../service/api";


export const getNewsLetter = createAsyncThunk(
    "news/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchNewsLetter(params)
            console.log("news plan", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getNewsLetterById = createAsyncThunk(
    "news/getById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchNewsLetterById(params)
            console.log("news by id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getNewsLetterDetails = createAsyncThunk(
    "news/getDetails",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchNewsLetterDetails(params)
            console.log("news details", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const removeNewsLetter = createAsyncThunk(
    "news/deleteNews",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteNewsLetter(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addNewsLetter = createAsyncThunk(
    "news/addNews",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createNewsLetter(formValue)
            if (response.status === 201) {
                console.log("news", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editNewLetter = createAsyncThunk(
    "news/editNews",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateNewsLetter(formValue)
            if (response.status === 201) {
                console.log("news", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const newLetterSlice = createSlice({
    name: "news",
    initialState: {
        newsLetterList: [],
        newsLetterById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },

    },

    extraReducers: (builder) => {
        builder
            .addCase(getNewsLetter.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getNewsLetter.fulfilled, (state, action) => {
                state.isLoading = false;
                state.newsLetterList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getNewsLetter.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //get id
            .addCase(getNewsLetterById.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getNewsLetterById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.newsLetterById = action.payload.data;
            })

            .addCase(getNewsLetterById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //get details
            .addCase(getNewsLetterDetails.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getNewsLetterDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.newsLetterById = action.payload.data;
            })

            .addCase(getNewsLetterDetails.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // POST
            .addCase(addNewsLetter.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addNewsLetter.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addNewsLetter.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(removeNewsLetter.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(removeNewsLetter.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(removeNewsLetter.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editNewLetter.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editNewLetter.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editNewLetter.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination } = newLetterSlice.actions;

export default newLetterSlice.reducer;
